import cs from "classnames";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC, ReactNode } from "react";

interface ItemProps {
  className?: string;
  label: ReactNode;
  onlyLabel?: boolean;
}

export const Item: FC<React.PropsWithChildren<ItemProps>> = observer(
  function Item(props) {
    const { className, label, onlyLabel, children } = props;
    return (
      <div className={cs("flex", "leading-10", className)}>
        <span className="font-semibold mr-3">
          {label}
          {onlyLabel ? null : ":"}
        </span>
        {onlyLabel ? null : children}
      </div>
    );
  },
);
